import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, UserRound } from "lucide-react";
import { APP_ICON_URL } from "@/lib/assets";
import { EntryDivider, EntryVaultShell } from "@/components/entry/EntryExperience";

export default function Home() {
  return (
    <EntryVaultShell>
      <section className="entry-landing">
        <div className="entry-landing__hero">
          <img src={APP_ICON_URL} alt="أيقونة بنك العائلة الرسمية" className="entry-landing__logo" />
          <h1 className="entry-landing__title">بنك العائلة</h1>
          <EntryDivider />
          <p className="entry-landing__slogan">ننمو معًا.</p>
          <nav className="entry-landing__actions" aria-label="بوابات الدخول">
            <Link to="/users" className="entry-entry-button entry-entry-button--gold" data-testid="home-user-entry">
              <UserRound aria-hidden="true" /><span>دخول المستخدم</span><ArrowLeft aria-hidden="true" />
            </Link>
            <Link to="/admin" className="entry-entry-button" data-testid="home-admin-entry">
              <ShieldCheck aria-hidden="true" /><span>دخول الإدارة</span><ArrowLeft aria-hidden="true" />
            </Link>
          </nav>
        </div>
        <footer className="entry-landing__footer">© {new Date().getFullYear()} بنك العائلة</footer>
      </section>
    </EntryVaultShell>
  );
}
